import axios from "axios";

axios.interceptors.request.use((config) => {
    return {
        ...config,
        baseURL: `${process.env.REACT_APP_API}`, // use your own URL here or environment variable
    };
});
